export const SIDEBAR_MENU_CLICK = "sidebar_menu_click";
export const SIDEBAR_SUBMENU_CLICK = "sidebar_submenu_click";
export const OPEN_WALLET_MODAL = "Connect_Wallet";
export const OPEN_ACCOUNT_MODAL = "wallet_modal";
export const OPEN_AUDIT_MODAL = "Audit_hyperlink";
export const CLOSE_WALLET_MODAL = "close_wallet_modal";
export const DISCONNECT_WALLET = "Disconnect_wallet";
export const TNC_ACCEPT = "Accept_TOS_Checkbox";
export const CLICK_TNC_LINK = "Read_Terms_of_services";

export const SWITCH_NETWORK = "Network_change";
export const HANDLE_ACTIVATE = "wallet_connect_started";
export const ACTIVATE_SUCCESS = "Wallet_connect_successful";
export const ACTIVATE_FAILED = "Wallet_connect_failed";
export const APPROVE_UNSTAKING = "approve_unstaking";

export const SELECT_TAB = "tab_click";

export const ADD_BNBX = "add_liquid_token";
export const MAX_STAKE = "max_stake";
export const ENTER_STAKE_AMOUNT = "enter_stake_amount";
export const SUBMIT_STAKE = "stake_cta";

export const ENTER_UNSTAKE_AMOUNT = "enter_unstake_amount";
export const MAX_UNSTAKE = "max_unstake";
export const SUBMIT_UNSTAKE = "unstake_cta";

export const SUBMIT_WITHDRAW = "withdraw_cta";

export const TRANSACTION_SUCCESS = "transaction_successful";
export const TRANSACTION_FAILURE = "transaction_failed";

export const COPY_ACCOUNT_ADDRESS = "Copy_Address";
export const VIEW_ADDRESS_ON_SCANNER = "Blockchain_explorer";
export const VIEW_TXN_ON_SCANNER = "Blockchain_explorer";
export const CLEAR_PAST_TRANSACTIONS = "Clear_all_transactions";

export const VIEW_AUDIT_REPORT = "Audit_type";
export const VIEW_SECURITY = "Security";
export const VIEW_BUG_BOUNTY = "Bug_bounty";

export const CLICK_STADER_LOGO = "Stader_logo";

export const CLICK_COMMUNITY_LINK = "Join_our_community";

export const PURCHASE_EVENT = "purchase";

export const CLICK_DEFI_PARTNER_LINK = "Defi";
export const CLICK_DEFI_PARTNER_CARD = "Defi_Carousel_strategy";
export const CLICK_DEFI_EXPLORE = "Defi_Carousel_CTA";

export const CLICK_FAQ_HOW_TO = "click_faq_how_to";

export const CLICK_DEFI_STARTEGY = "Defi_strategy";
export const CLICK_MAX_YIELD = "Max_yield";
export const PROCEED_UNSTAKE = "Proceed_unstake";

export const LEARN_MORE = "Learn_more_blockchain";
export const FAQ = "FAQ";
export const SUPPORT = "Support";

// home page
export const PRIMARY_TABS = "primary_tabs";
export const STAKE_NOW_CTA = "stake_now_CTA";
export const BNBX_AUDIT = "bnbx_audit";
export const BNBX_BUG_BOUNTY = "bnbx_bug_bounty";
export const VIEW_OUR_PARTNERS = "view_our_partners";
export const BNBX_SOCIALS = "bnbx_socials";
export const SUBSCRIBE_EMAIL = "subscribe_email";
export const SUBSCRIBE_PRIVACY = "subscribe_privacy";
export const READ_MORE_FAQ = "subscribe_privacy";
export const EXPLORE_BNB_PORTFOLIOS = "explore_bnb_portfolios";
export const WATCH_BNB_WORKS = "watch_bnb_works";
export const STAKE_BNB_REWARD_CALCULATOR = "stake_bnb_reward_calculator";

// Portfolios
export const OPEN_PORTFOLIO = "open_portfolio";
export const LET_US_KNOW_CTA = "let_us_know_cta";
export const ENTER_DEPOSIT_AMOUNT = "enter_deposit_amount";
export const DEPOSIT_MAX_CTA = "deposit_max_cta";
export const DEPOSIT_CTA = "deposit_cta";
export const KNOW_MORE_CTA = "know_more_portfolio";
export const CLICK_PORTFOLIO_TAB = "click_portfolio_tab";
export const ENTER_WITHDRAW_AMOUNT = "enter_withdraw_amount";
export const WITHDRAW_MAX_CTA = "withdraw_max_cta";
export const WITHDRAW_IN_BNB = "withdraw_in_bnb";
export const WITHDRAW_CTA = "withdraw_cta";

// Filters
export const ALL_FILTER = "all_filter";
export const TAG_FILTER = "tag_filter";
export const CATEGORY_FILTER = "category_filter";

// Liquid staking options
export const EXPLORE_STAKING = "Explore_staking";
